import { TourIntroductionLine } from 'Components/lines/tour-introduction-line/TourIntroductionLine';
export default TourIntroductionLine;
